export class SimpleUser {
  user: string;
  id: number;

  constructor(id?: number, user?: string) {
    this.user = user || '';
    this.id = id || -1;
  }
}
